document.addEventListener("turbo:load", function() {
  const container = document.getElementById("registration_form");
  if (!container) return;

  console.log("Load: registrations/form_actions.js");

  $(".form_field[style$='display:none;']").find('input, select').removeAttr('required');

	$("input[name=choose_donation]").on("change", function() {
		if ( $(this).val() == 'yes' ) {
			$('#donation_fundraiser_id').val( $(this).data('fundraiser-id') );
		}
	});

  const raw = container.dataset.regDependencies;
  if (!raw) return;

  const dependencies = JSON.parse(raw);
  $.each(dependencies, function(_index, dep) {
    const trigger = $(dep.trigger_type + '[data-id="' + dep.trigger + '"]');
    const dependent = $(dep.dependent_type + '[data-id="' + dep.dependent + '"]');

    trigger.on("change", function () {
      if (dep.trigger_shows_dependent) {
        trigger.is(":checked") ? show(dependent) : hide(dependent);
      } else {
        trigger.is(":checked") ? hide(dependent) : show(dependent);
      }
    });
  });

  function show(dependency) {
    dependency.slideDown();
    if (dependency.data('required') == true) {
      dependency.find('input, select').attr('required', 'required');
    }
  }

  function hide(dependency) {
    dependency.slideUp();
    dependency.find('input, select').removeAttr('required');
    window.clearFields(dependency);
  }
});